import React, { useEffect, useState } from "react";
import { DatePicker, ConfigProvider, Space } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import useThemeStore from "(store)/themeStore";

dayjs.extend(customParseFormat);

const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
const { RangePicker } = DatePicker;

const DateRangePickerField = ({ placeholder, onChange, isReset = false}) => {
  const [isFocused, setIsFocused] = useState(false);
  const theme = useThemeStore((state) => state.theme);
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });
  const [rangePickerValue, setRangePickerValue] = useState(null);

  const handleDateChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setDates({
        startDate: start.format("YYYY-MM-DD"),
        endDate: end.format("YYYY-MM-DD"),
      });
    }
    setRangePickerValue(dates);
  };

  useEffect(() => {
    onChange(dates);
  }, [dates, onChange]);
  return (
    <div className="hidden md:flex">
      {/* {label && (
        <div className="label">
          <span className="label-text font-bold">
            {label} <span className="label-text text-red-700">*</span>
          </span>
        </div>
      )} */}

      <ConfigProvider
        theme={{
          token: {
            colorPrimary:
              theme === "dark" && isFocused
                ? "#FAB54E"
                : theme !== "dark" && isFocused
                ? "#1996a6"
                : "#d1d5db",
            colorTextPlaceholder: "#d1d5db",
          },
          components: {
            DatePicker: {
              colorPrimary: "tranparent",
            },
          },
        }}
      >
        <Space direction="vertical" size={1}>
          <RangePicker
            format={dateFormatList[2]}
            size="small"
            value={isReset ? null : rangePickerValue}
            onChange={handleDateChange}
            onFocus={() => {
              setIsFocused(true);
            }}
            onBlur={() => {
              setIsFocused(false);
            }}
            placeholder={placeholder || ["Start date", "End date"]}
            style={{ width: "230px" }}
            className={`
            flex w-full py-2 border-2	 border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg 
            focus:outline-none   focus-within:border-[#1996A6]  hover:border-2 hover:${
              isFocused ? "border-secondary" : "border-gray-300"
            } 
          dark:focus-within:border-[#FAB54E] dark:bg-slate-950 dark:focus-within:bg-white dark:focus-within:text-black dark:text-gray-300
          `}
          />
        </Space>
      </ConfigProvider>
    </div>
  );
};

export default DateRangePickerField;
